export default __webpack_public_path__ + "static/media/SubmittedYellow.d278c957.svg";